// src/Pages/Landing/JoyrideEtelaPohjanmaaLanding.jsx
import React from "react";
import JoyrideMaakuntaLanding from "./JoyrideMaakuntaLanding.jsx";

export default function JoyrideEtelaPohjanmaaLanding() {
  return (
    <JoyrideMaakuntaLanding
      maakunta="Etelä-Pohjanmaa"
      cities={[
        "Seinäjoki",
        "Lapua",
        "Kauhava",
        "Kurikka",
        "Ilmajoki",
        "Alavus",
        "Ähtäri"
      ]}
      regionText="Bilebändi Joyride tekee keikkoja myös Etelä-Pohjanmaan alueelle tapahtuman luonteesta, aikataulusta ja matkasta riippuen. Seinäjoen seutu ja lähikunnat sopivat hyvin esimerkiksi häihin, yritysjuhliin, kesäjuhliin ja pikkujouluihin, kun juhliin halutaan energinen livebändi."
      bookingLink="/#varaa"
    />
  );
}